<template>
  <div class="services">
    <section class="services-hero">
      <div class="services-hero-bg">
        <img src="/static/fw.png" alt="服务项目">
        <!-- <div class="services-hero-overlay"></div> -->
      </div>
    <!--  <div class="services-hero-content">
        <h1 class="fade-in-up">服务项目</h1>
        <p class="hero-subtitle fade-in-up delay-1">OUR SERVICES</p>
        <div class="breadcrumb fade-in-up delay-2">
          <router-link to="/">首页</router-link>
          <span>/</span>
          <span>服务项目</span>
        </div>
      </div> -->
    </section>

    <section class="services-list-section">
      <div class="container">
        <div class="services-items">
          <div
            v-for="(service, index) in servicesList"
            :key="service.id"
            :id="'service-' + service.id"
            :class="['service-item', { 'reverse': index % 2 === 1 }]"
            :data-aos="index % 2 === 0 ? 'fade-right' : 'fade-left'"
          >
            <div class="service-item-image">
              <img :src="service.image" :alt="service.name">
              <div class="service-item-overlay"></div>
            </div>
            <div class="service-item-content">
              <div class="service-item-number">{{ String(index + 1).padStart(2, '0') }}</div>
              <div class="service-item-subtitle">{{ service.subtitle }}</div>
              <h3 class="service-item-title">{{ service.name }}</h3>
              <p class="service-item-desc">{{ service.description }}</p>
             <!-- <a href="#" class="service-item-link">
                了解详情
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M5 12h14M12 5l7 7-7 7"/>
                </svg>
              </a> -->
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="services-cta section-padding">
      <div class="container">
        <div class="cta-card card">
          <div class="cta-content" data-aos="fade-right">
            <h2>需要专业咨询服务？</h2>
            <p>我们的专家团队随时为您提供一对一的咨询服务，助力您的项目成功</p>
          </div>
          <div class="cta-actions" data-aos="fade-left">
            <router-link to="/contact" class="btn-primary">联系我们</router-link>
            <button class="btn-secondary">获取报价</button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { fuwuServices } from '@/api/mock'

export default {
  name: 'Services',
  data() {
    return {
      servicesList: fuwuServices
    }
  }
}
</script>

<style lang="scss" scoped>
.services-hero {
  position: relative;
  height: 420px;
  overflow: hidden;
}

.services-hero-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.services-hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(15, 23, 42, 0.85) 0%, rgba(26, 86, 219, 0.7) 100%);
}

.services-hero-content {
  position: relative;
  z-index: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 0 20px;
}

.services-hero-content h1 {
  font-size: 56px;
  font-weight: bold;
  color: white;
  margin-bottom: 12px;
  letter-spacing: 4px;
}

.hero-subtitle {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.85);
  letter-spacing: 6px;
  margin-bottom: 24px;
  font-weight: 300;
}

.breadcrumb {
  display: flex;
  align-items: center;
  gap: 10px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 15px;

  a {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    transition: color 0.3s ease;

    &:hover {
      color: white;
    }
  }
}

.services-list-section {
  padding: 80px 0;
  background: #f8fafc;
}

.services-items {
  display: flex;
  flex-direction: column;
  gap: 50px;
}

.service-item {
  display: flex;
  align-items: stretch;
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.06);
  transition: all 0.4s ease;

  &:hover {
    box-shadow: 0 15px 50px rgba(0, 0, 0, 0.12);
    transform: translateY(-4px);

    .service-item-image img {
      transform: scale(1.05);
    }

    .service-item-link {
      padding-left: 8px;

      svg {
        transform: translateX(4px);
      }
    }
  }

  &.reverse {
    flex-direction: row-reverse;

    .service-item-content {
      padding: 50px 50px 50px 60px;
    }

    .service-item-number {
      right: auto;
      left: -10px;
    }

    .service-item-link {
      align-self: flex-end;
    }
  }
}

.service-item-image {
  position: relative;
  width: 45%;
  min-height: 320px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.6s ease;
  }

  .service-item-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, rgba(26, 86, 219, 0.1), rgba(79, 70, 229, 0.1));
  }
}

.service-item-content {
  flex: 1;
  padding: 50px 60px 50px 50px;
  display: flex;
  flex-direction: column;
  position: relative;
}

.service-item-number {
  position: absolute;
  top: 30px;
  right: 40px;
  font-size: 120px;
  font-weight: 800;
  color: transparent;
  -webkit-text-stroke: 1.5px rgba(26, 86, 219, 0.2);
  line-height: 1;
  font-family: 'Arial', sans-serif;
  pointer-events: none;
}

.service-item-subtitle {
  font-size: 13px;
  font-weight: 500;
  color: #1a56db;
  letter-spacing: 3px;
  margin-bottom: 12px;
  position: relative;
  z-index: 1;
}

.service-item-title {
  font-size: 28px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 18px;
  line-height: 1.4;
  position: relative;
  z-index: 1;
}

.service-item-desc {
  font-size: 15px;
  color: #64748b;
  line-height: 1.8;
  margin-bottom: 30px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  position: relative;
  z-index: 1;
}

.service-item-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #1a56db;
  font-size: 15px;
  font-weight: 600;
  text-decoration: none;
  padding: 12px 0;
  transition: all 0.3s ease;
  position: relative;
  z-index: 1;
  border-bottom: 2px solid transparent;
  align-self: flex-start;

  svg {
    width: 18px;
    height: 18px;
    transition: transform 0.3s ease;
  }
}

.services-cta {
  padding: 80px 0;
}

.cta-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 60px;
  background: linear-gradient(135deg, #1a56db 0%, #4f46e5 100%);
  border-radius: 16px;

  .cta-content {
    h2 {
      font-size: 32px;
      font-weight: bold;
      color: white;
      margin-bottom: 15px;
    }

    p {
      font-size: 16px;
      color: rgba(255, 255, 255, 0.8);
      max-width: 500px;
    }
  }

  .cta-actions {
    display: flex;
    gap: 20px;
  }

  .btn-primary {
    background: white;
    color: #1a56db;

    &:hover {
      background: rgba(255, 255, 255, 0.9);
    }
  }

  .btn-secondary {
    background: transparent;
    color: white;
    border-color: white;

    &:hover {
      background: rgba(255, 255, 255, 0.1);
    }
  }
}

@media (max-width: 992px) {
  .service-item,
  .service-item.reverse {
    flex-direction: column;
  }

  .service-item-image {
    width: 100%;
    min-height: 260px;
  }

  .service-item-content,
  .service-item.reverse .service-item-content {
    padding: 40px 35px;
  }

  .service-item-number {
    font-size: 80px;
    top: 25px;
    right: 30px;
  }
}

@media (max-width: 768px) {
  .services-hero {
    height: 340px;
  }

  .services-hero-content h1 {
    font-size: 38px;
    letter-spacing: 2px;
  }

  .hero-subtitle {
    font-size: 14px;
    letter-spacing: 4px;
  }

  .services-list-section {
    padding: 50px 0;
  }

  .services-items {
    gap: 35px;
  }

  .service-item-content,
  .service-item.reverse .service-item-content {
    padding: 35px 28px;
  }

  .service-item-title {
    font-size: 22px;
  }

  .service-item-number {
    font-size: 60px;
    top: 20px;
    right: 25px;
  }

  .cta-card {
    flex-direction: column;
    text-align: center;
    gap: 30px;
    padding: 40px 25px;
  }

  .cta-actions {
    flex-direction: column;
    width: 100%;

    button, a {
      width: 100%;
      text-align: center;
    }
  }
}

/* ===== 小屏手机适配 ===== */
@media (max-width: 480px) {
  .services-hero {
    height: 240px;
  }

  .services-list-section {
    padding: 40px 0;
  }

  .services-items {
    gap: 25px;
  }

  .service-item-image {
    min-height: 200px;
  }

  .service-item-content,
  .service-item.reverse .service-item-content {
    padding: 25px 20px;
  }

  .service-item-number {
    font-size: 48px;
    top: 16px;
    right: 18px;
  }

  .service-item-subtitle {
    font-size: 11px;
    letter-spacing: 2px;
    margin-bottom: 8px;
  }

  .service-item-title {
    font-size: 19px;
    margin-bottom: 14px;
  }

  .service-item-desc {
    font-size: 13px;
    line-height: 1.7;
    -webkit-line-clamp: 4;
    margin-bottom: 20px;
  }

  .services-cta {
    padding: 40px 0;
  }

  .cta-card {
    padding: 30px 20px;

    .cta-content h2 {
      font-size: 24px;
    }

    .cta-content p {
      font-size: 14px;
    }
  }
}
</style>
